import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import CountryLink from 'Components/common/CountryLink';
import React from 'react';
import SmartText from '@reuters-graphics/react-smart-text';

const atlas = new AtlasMetadataClient();

const IMG = '//graphics.thomsonreuters.com/data/2020/coronavirus/global-tracker';

const Headline = ({ smartText }) => {
  const { source, context } = smartText;
  const country = atlas.getCountry(context.country);
  const imageSrc = country ?
    `${IMG}/countries/${country.slug}/charts/${context.metric}.svg` :
    `${IMG}/charts/${context.metric}.svg`; // Global SVGs
  return (
    <div>
      <figure>
        <img src={imageSrc} />
      </figure>
      <SmartText
        source={source}
        context={{
          ...context,
          country: country ? <CountryLink country={country.isoAlpha2} /> : null,
        }}
        wrap
      />
    </div>
  );
};

export default Headline;
